/**
 * 横スクロールできるテーブルにスワイプ案内を表示する
 **/
(function () {
  "use strict";

  var hintClass = "table-scroll-hint";
  var readyClass = "table-scroll-hint-ready";
  var hiddenClass = "table-scroll-hint-hidden";
  var dismissedClass = "table-scroll-hint-dismissed";
  var observer = null;

  function shouldShowHint(element) {
    if (!element || element.classList.contains(dismissedClass)) {
      return false;
    }
    return element.scrollWidth > element.clientWidth + 8;
  }

  function hideHint(element) {
    element.classList.add(hiddenClass);
    element.classList.add(dismissedClass);
    element.classList.remove(readyClass);
  }

  function appendHint(element) {
    if (element.querySelector("." + hintClass)) {
      return;
    }

    var hint = document.createElement("span");
    hint.className = hintClass;
    hint.setAttribute("aria-hidden", "true");
    hint.innerHTML = [
      '<span class="table-scroll-hint__hand">',
      '<svg class="table-scroll-hint__icon" viewBox="0 0 96 96" role="img" focusable="false" aria-label="横スクロールできます">',
      '<path class="table-scroll-hint__arrow" d="M14 28h18M14 28l7-7M14 28l7 7M82 28H64M82 28l-7-7M82 28l-7 7"/>',
      '<path class="table-scroll-hint__palm" d="M42 80c-9 0-16-5-20-13l-9-18c-2-4 0-8 4-10s8 0 10 4l5 9V24c0-5 4-9 9-9s9 4 9 9v24-17c0-5 4-8 8-8s8 3 8 8v21-15c0-4 3-8 8-8s8 4 8 8v18c0 15-10 25-25 25H42z"/>',
      '<path class="table-scroll-hint__line" d="M32 52V24M50 49V31M66 52V37"/>',
      '</svg>',
      '</span>'
    ].join("");
    element.appendChild(hint);
  }

  function bindDismissEvents(element) {
    if (element.getAttribute("data-table-scroll-hint-bound") === "1") {
      return;
    }

    element.setAttribute("data-table-scroll-hint-bound", "1");

    element.addEventListener("scroll", function () {
      hideHint(element);
    }, { once: true });

    element.addEventListener("touchstart", function () {
      hideHint(element);
    }, { once: true });

    element.addEventListener("pointerdown", function () {
      hideHint(element);
    }, { once: true });

    element.addEventListener("wheel", function () {
      hideHint(element);
    }, { once: true });
  }

  function showHint(element) {
    if (!shouldShowHint(element)) {
      element.classList.remove(readyClass);
      return;
    }

    element.classList.add(readyClass);
    element.classList.remove(hiddenClass);
    bindDismissEvents(element);

    if (element.getAttribute("data-table-scroll-hint-timer") === "1") {
      return;
    }

    element.setAttribute("data-table-scroll-hint-timer", "1");
    window.setTimeout(function () {
      if (!element.classList.contains(dismissedClass)) {
        hideHint(element);
      }
    }, 4500);
  }

  function observeHint(element) {
    if (!("IntersectionObserver" in window)) {
      showHint(element);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        Array.prototype.forEach.call(entries, function (entry) {
          if (entry.isIntersecting) {
            showHint(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.35
      });
    }

    if (element.getAttribute("data-table-scroll-hint-observed") === "1") {
      return;
    }

    element.setAttribute("data-table-scroll-hint-observed", "1");
    observer.observe(element);
  }

  function initTableScrollHint() {
    var elements = document.querySelectorAll(".table-scroll");

    Array.prototype.forEach.call(elements, function (element) {
      appendHint(element);

      if (!shouldShowHint(element)) {
        element.classList.remove(readyClass);
        return;
      }

      observeHint(element);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTableScrollHint);
  } else {
    initTableScrollHint();
  }

  document.addEventListener("customDOMContentLoaded", initTableScrollHint);
  window.addEventListener("resize", initTableScrollHint);
}());
